import { useQuery } from "@tanstack/react-query";

import { ReportQAResult, getLatestReportQA } from "../../api/reportQa";
import { CLIENT_KEYS } from "../../constants/clientKeys";

/**
 * Fetch the latest persisted Report QA pass for a given draft response.
 *
 * Returns `null` (not an error) when no QA has been run yet, matching
 * the backend's `GET .../report-qa/latest` contract.
 */
export const useLatestReportQA = ({
  templateId,
  caseNumber,
  enabled = true,
}: {
  templateId: string;
  caseNumber: string;
  enabled?: boolean;
}) => {
  return useQuery<ReportQAResult | null>({
    queryKey: [
      CLIENT_KEYS.REPORT_GENERATOR,
      CLIENT_KEYS.TEMPLATES,
      templateId,
      CLIENT_KEYS.CASES,
      caseNumber,
      CLIENT_KEYS.REPORT_QA,
    ],
    queryFn: () => getLatestReportQA({ templateId, caseNumber }),
    enabled: enabled && !!templateId && !!caseNumber,
  });
};
